import { io } from "socket.io-client";

const URL = process.env.REACT_APP_BASEURL; // Or from env

const socket = io(URL, {
    transports: ["websocket", "polling"],
    withCredentials: true,
    // query: { USER_ID: "xyz" }, // optional
});

export default socket;
